

// import {
//   Backdrop,
//   FormControl,
//   IconButton,
//   InputAdornment,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
//   ThemeProvider,
//   Tooltip,
// } from "@mui/material";
// import React, { useEffect, useState, useMemo, useRef } from "react";
// import { Link, useHistory } from "react-router-dom";
// import { useFormik } from "formik";
// import * as yup from "yup";
// // import AccessLevel from "./AccessLevel";
// import { createTheme } from "@mui/material/styles";
// import { common_axios } from "../../../../App";
// import { toast } from "react-toastify";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import Loader from "../../../../components/Loader";
// import PersonIcon from "@mui/icons-material/Person";
// import InfoIcon from "@mui/icons-material/Info";
// import {
//   useAsyncDebounce,
//   useFilters,
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
// } from "react-table";
// import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
// import SecureMessageRadioButton from "./SecureMessageRadioButton";
// import KeyIcon from "@mui/icons-material/Key";
// import Box from "@mui/material/Box";
// import Skeleton from "@mui/material/Skeleton";
// import CancelIcon from "@mui/icons-material/Cancel";
// import Swal from "sweetalert2";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { max } from "date-fns";
// export default function AddReseller() {
//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: {
//             color: "red",
//           },
//         },
//       },
//     },
//   });
//   const defaultColumn = useMemo(() => {
//     return {
//       Filter: ColumnFilter,
//     };
//   }, []);
//   const [hideSkeleton, setHideSkeleton] = useState();
//   const [open, setOpen] = useState(false);
//   const [removeTooltip, setremoveTooltip] = useState(false);
//   const [age, setAge] = React.useState("User");
//   const [filterDropDown, setFilterDropDown] = React.useState("0");
//   const [transactionalDropDown, setTransactionalDropDown] = React.useState("0");
//   const [DeliveryReportDropDown, setDeliveryReportDropDown] =
//     React.useState("0");
//   const [statusDropDown, setStatusDropDown] = React.useState("1");
//   const [maskNumberDropDown,setMaskNumberDropDown] = React.useState("0");

//   const [secureMessage, setSecureMessage] = useState("None or Default");
//   const [textField, setTextField] = useState("");
//   const [openTable, setOpenTable] = useState(false);
//   const [verify, setVerify] = useState("");
//   const [documents, setDocuments] = useState("");
//   const [user, setUser] = useState("");
//   const [data, setdata] = useState([]);
//   const [maxLimit, setMaxLimit] = useState();
//   const [showPassword, setShowPassword] = useState(false);
//   const [variantName, setVariantName] = React.useState([]);
//   const [variantNameEmpty, setVariantNameEmpty] = React.useState();
//   const [checkUsernameError, setCheckUsernameError] = React.useState("");
//   const [error, seterror] = useState(false);
//   const [hideSkeleton1, setHideSkeleton1] = useState();

//    console.log("uioo", error);
//   const [Ip, setIp] = useState("");
//   const [part1, setPart1] = useState("");
//   const [part2, setPart2] = useState("");
//   const [part3, setPart3] = useState("");
//   const [part4, setPart4] = useState("");
//   const inputRef1 = useRef(null);
//   const inputRef2 = useRef(null);
//   const inputRef3 = useRef(null);
//   const inputRef4 = useRef(null);
//   // console.log("oip", Ip);
//   const handleInputChange = (event) => {
//     const value = event.target.value;
//     if ((value >= 0 && value <= 255) || value == "*") {
//       setPart1(value);
//     }
//   };
//   const handleInputChange2 = (event) => {
//     const value = event.target.value;
//     if ((value >= 0 && value <= 255) || value == "*") {
//       setPart2(value);
//     }
//   };
//   const handleInputChange3 = (event) => {
//     const value = event.target.value;
//     if ((value >= 0 && value <= 255) || value == "*") {
//       setPart3(value);
//     }
//   };
//   const handleInputChange4 = (event) => {
//     const value = event.target.value;
//     if ((value >= 0 && value <= 255) || value == "*") {
//       setPart4(value);
//     }
//   };

//   useEffect(() => {
//     if (part1.length == 3 || part1 == "*") {
//       inputRef2.current.focus();
//     }
//   }, [part1]);

//   useEffect(() => {
//     if (part2.length == 3 || part2 == "*") {
//       inputRef3.current.focus();
//     }
//   }, [part2]);

//   useEffect(() => {
//     if (part3.length == 3 || part3 == "*") {
//       inputRef4.current.focus();
//     }
//   }, [part3]);

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     // console.log("Submitted:", part1, part2, part3, part4);
//   };

//   const handleChange = (event) => {
//     setAge(event.target.value);
//   };
//   const handleChange1 = (event) => {
//     setFilterDropDown(event.target.value);
//   };
//   const handleChange2 = (event) => {
//     setTransactionalDropDown(event.target.value);
//   };
//   const handleChange3 = (event) => {
//     setDeliveryReportDropDown(event.target.value);
//   };
//   const handleChange4 = (event) => {
//     setStatusDropDown(event.target.value);
//   };
//   const handleChange5 = (event) => {
//     setMaskNumberDropDown(event.target.value);
//   };

//   const columns = useMemo(
//     () => [
//       // {
//       //   Header: "Id",
//       //   Footer: "Id",
//       //   accessor: "uid",
//       //   // Cell: (cell) => {
//       //   //   console.log(resellerResponse.uid);
//       //   //   return (
//       //   //     // <div>
//       //   //     //   {cell.row.original.roleName == "user" ? (
//       //   //     //     <div>User</div>
//       //   //     //   ) : (
//       //   //     //     <div>Reseller</div>
//       //   //     //   )}
//       //   //     // </div>
//       //   //     <>{resellerResponse?.uid}</>
//       //   //   );
//       //   // }, // accessor is the "key" in the data
//       // },

//       // {
//       //   Header: "Id",
//       //   accessor: "uid",
//       //   Cell: (cell ) => (
//       //    <>{cell.row.index +1}</>
//       //   ),
//       // },
//       {
//         Header: "User Name",
//         Footer: "User Name",
//         accessor: "username",
//         // Cell: (cell) => {
//         //   console.log(resellerResponse.username);
//         //   return (
//         //     // <div>
//         //     //   {cell.row.original.roleName == "user" ? (
//         //     //     <div>User</div>
//         //     //   ) : (
//         //     //     <div>Reseller</div>
//         //     //   )}
//         //     // </div>
//         //     <>{resellerResponse?.username}</>
//         //   );
//         // }, // accessor is the "key" in the data
//       },
//       // {
//       //   Header: "Role",
//       //   Footer: "Role",
//       //   accessor: "userRoleId",
//       // },
//       {
//         Header: "Email-Id",
//         Footer: "Email-Id",
//         accessor: "email",
//         Cell: (cell) => {
//           // console.log(resellerResponse.email);
//           return (
//             <div>
//               {cell.row.original.email ? (
//                 <div>{cell.row.original.email}</div>
//               ) : (
//                 <div>N/A</div>
//               )}
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Role",
//         Footer: "Role",
//         accessor: "roleName",
//         // Cell: (cell) => {
//         //   console.log(resellerResponse.roleName);
//         //   return (
//         //     // <div>
//         //     //   {cell.row.original.roleName == "user" ? (
//         //     //     <div>User</div>
//         //     //   ) : (
//         //     //     <div>Reseller</div>
//         //     //   )}
//         //     // </div>
//         //     <>{resellerResponse?.roleName}</>
//         //   );
//         // },
//       },
//       {
//         Header: "Status",
//         Footer: "Status",
//         accessor: "status",
//         Cell: (cell) => {
//           // console.log(cell.row.original.approved, cell.row.original.status);
//           return (
//             <>
//               {cell.row.original.approved == 0 ? (
//                 <>
//                   <div className="badge badge_8 bg-warning">Pending</div>
//                 </>
//               ) : cell.row.original.approved == 1 ? (
//                 <>
//                   {" "}
//                   <div className="badge badge_8 bg-success">Approved</div>
//                 </>
//               ) : (
//                 <>
//                   {" "}
//                   <div className="badge badge_8 bg-danger">Rejected</div>
//                 </>
//               )}
//             </>
//           );
//         },
//       },
//     ],
//     []
//   );
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     rows,
//     page,
//     nextPage,
//     canNextPage,
//     previousPage,
//     canPreviousPage,
//     pageOptions,
//     gotoPage,
//     pageCount,
//     setPageSize,
//     prepareRow,
//     state,
//     setGlobalFilter,
//     getToggleHideAllColumnsProps,
//   } = useTable(
//     {
//       columns,
//       data,
//       defaultColumn,
//       // initialState: { pageIndex: 1 }
//     },
//     useFilters,
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//     useRowSelect
//   );

//   const { globalFilter, pageIndex, pageSize } = state;
//   const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);
//   const onChange = useAsyncDebounce((value) => {
//     setGlobalFilter(value || undefined);
//   }, 1000);
//   const handleMouseDownPassword = () => setShowPassword(!showPassword);
//   const handleClickShowPassword = () => setShowPassword(!showPassword);
//   const callbackFunction = (childData) => {
//     setVerify(childData);
//   };
//   const callbackFunction1 = (childData) => {
//     setDocuments(childData);
//   };
//   const callbackFunction2 = (childData) => {
//     setUser(childData);
//   };
//   const callbackSecureMesage = (child) => {
//     setSecureMessage(child);
//     // console.log("first", child);
//   };
//   const userId = localStorage.getItem("UserId");
//   const validationSchema = yup.object({
//     password: yup
//       .string("Enter Your Password")
//       .matches(
//         /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
//         "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
//       )
//       .required("Password required"),
//     name: yup
//       .string("Enter your Name")
//       .min(2, "Name should be of minimum 2 characters length")
//       .required("Name is required"),

//     email: yup
//     .string()
//     .email("E-Mail must be valid")
//     .max(255),
//     // .required("E-Mail  is required"),
//     userName: yup
//       .string("Enter Your Username")
//       .min(3, "Username should be at least 3 characters long")
//       .required("*Username is required")
//       .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),
//     phoneNumber: yup
//       // .number("Enter your PhoneNumber")
//       // .min(10000000,"Minimum length of a mobile number is 8 digits")
//       // .max(
//       //   100000000,
//       //   "Maximum length of mobile number is 8 digits"
//       // )
//       .string()
//       .min(8, "Minimum length of a mobile number is 8 digits")
//       .max(8, "Maximum length of mobile number is 8 digits")
//     //  .required("Required"),
//       .required("PhoneNumber is required"),
//   });
//   const formik = useFormik({
//     initialValues: {
//       userName: "",
//       phoneNumber: "",
//       email: "",
//       password: "",
//       name: "",
//       encryptedMessage: "",
//       tpsLimit:"1",
//     },
//     onReset: (initialValues) => ({
//       values: { initialValues },
//     }),
//     validateOnChange: true,
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       if (secureMessage == "DES Encryption") {
//         // alert("if")
//         // console.log("firs5t", part1);
//         // setIp(part1+"."+part2+"."+part3+"."+part4)
//         try {
//           setOpen(true);
//           const res = await common_axios.post(`admin/v1/create/`, {
//             userName: values.userName,
//             password: values.password,
//             name: values.name,
//             email: values.email,
//             phoneNumber: "222"+values.phoneNumber,
//             // is2factorAuth: 0,
//             // emailVerification: verify,
//             // documents: [""],
//             role: age,
//             userId: userId,
//             // ip:Ip,
//             // ip: part1 + "." + part2 + "." + part3 + "." + part4,
//             ip:
//               part1 != "" && part2 != "" && part3 != "" && part4 != ""
//                 ? part1 + "." + part2 + "." + part3 + "." + part4
//                 : "",
//             encryptedMessage: values.encryptedMessage,
//             status: statusDropDown,
//             deliveryReportRequest: DeliveryReportDropDown,
//             allowTransSenderName: transactionalDropDown,
//             filterMessage: filterDropDown,
//             tpsLimit:values.tpsLimit,
//             createdUser: localStorage.getItem("usernamedisplayed")
//           });
//           // console.log(res.data);
//           // const status = res.data.statusDescription.statusCode;
//           if (res.data.statusDescription.statusCode == 200) {
//             setVariantNameEmpty([]);
//             await formik.handleReset();
//             setAge(null);
//             setremoveTooltip(false)
//             setPart1("");
//             setPart2("");
//             setPart3("");
//             setPart4("");
//             setSecureMessage();
//             setOpen(true);
//             setTimeout(() => {
//               setOpen(false);
//             }, 500);

//             setOpen(false);
//             await setOpenTable(true);
//             await setdata([...data, res.data.userDetail]);

//             await setTimeout(async () => {
//               // await toast.success("User Created SuccessFully", {
//               //   theme: "colored",
//               // });
//               Swal.fire({
//                 icon: "success",
//                 //  title: "Oops...",
//                 text: "User Created SuccessFully",
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }, 100);
//           } else {
//             setOpen(false);
//             await setTimeout(async () => {
//               // await toast.error(res.data.statusDescription.description, {
//               //   theme: "colored",
//               // });
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: res.data.statusDescription.description,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }, 100);
//           }
//         } catch (error) {
//           setOpen(false);
//           // console.log(error);
//           await setTimeout(async () => {
//             // await toast.error("Something went wrong", {
//             //   theme: "colored",
//             // });
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Something went wrong",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }, 100);
//         }
//       } else if (secureMessage == "AES256 Encryption") {
//         // setIp(part1+"."+part2+"."+part3+"."+part4)
//         // alert("if")
//         try {
//           setOpen(true);
//           const res = await common_axios.post(`admin/v1/create/`, {
//             userName: values.userName,
//             password: values.password,
//             name: values.name,
//             email: values.email,
//             phoneNumber: "222"+values.phoneNumber,
//             // is2factorAuth: 0,
//             // emailVerification: verify,
//             // documents: [""],

//             role: age,
//             userId: userId,
//             ip:
//             part1 != "" && part2 != "" && part3 != "" && part4 != ""
//               ? part1 + "." + part2 + "." + part3 + "." + part4
//               : "",           
//                encryptedMessage: values.encryptedMessage,
//             status: statusDropDown,
//             deliveryReportRequest: DeliveryReportDropDown,
//             allowTransSenderName: transactionalDropDown,
//             filterMessage: filterDropDown,
//             tpsLimit:values.tpsLimit,
//             createdUser: localStorage.getItem("usernamedisplayed")
//           });

//           // console.log(res.data);
//           // const status = res.data.statusDescription.statusCode;
//           if (res.data.statusDescription.statusCode == 200) {   
//             setVariantNameEmpty([]);
//             await formik.handleReset();
//             setAge(null);
//             setOpen(true);
//             setremoveTooltip(false)
//             setPart1("");
//             setPart2("");
//             setPart3("");
//             setPart4("");
//             setTimeout(() => {
//               setOpen(false);
//             }, 500);

//             setOpen(false);
//             await setOpenTable(true);
//             await setdata([...data, res.data.userDetail]);

//             await setTimeout(async () => {
//               // await toast.success("User Created SuccessFully", {
//               //   theme: "colored",
//               // });
//               Swal.fire({
//                 icon: "success",
//                 //  title: "Oops...",
//                 text: "User Created SuccessFully",
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }, 100);
//           } else {
//             setOpen(false);
//             await setTimeout(async () => {
//               // await toast.error(res.data.statusDescription.description, {
//               //   theme: "colored",
//               // });
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: res.data.statusDescription.description,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }, 100);
//           }
//         } catch (error) {
//           setOpen(false);
//           // console.log(error);
//           await setTimeout(async () => {
//             // await toast.error("Something went wrong", {
//             //   theme: "colored",
//             // });
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Something went wrong",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }, 100);
//         }
//       } else {
//         // setIp(part1+"."+part2+"."+part3+"."+part4)
//         // alert("else")
//         try {
//           setOpen(true);
//           const res = await common_axios.post(`admin/v1/create/`, {
//             userName: values.userName,
//             password: values.password,
//             name: values.name,
//             email: values.email,
//             phoneNumber: "222"+values.phoneNumber,
//             // is2factorAuth: 0,
//             // emailVerification: verify,
//             // documents: [""],
//             role: age,
//             userId: userId,
//             ip:
//             part1 != "" && part2 != "" && part3 != "" && part4 != ""
//               ? part1 + "." + part2 + "." + part3 + "." + part4
//               : "",         
//                  encryptedMessage: secureMessage,
//             status: statusDropDown,
//             deliveryReportRequest: DeliveryReportDropDown,
//             allowTransSenderName: transactionalDropDown,
//             filterMessage: filterDropDown,
//             tpsLimit:values.tpsLimit,
//             createdUser: localStorage.getItem("usernamedisplayed")
//           });

//           // console.log(res.data);

//           // const status = res.data.statusDescription.statusCode;

//           if (res.data.statusDescription.statusCode == 200) {
//             setVariantNameEmpty([]);
//             await formik.handleReset();
//             setremoveTooltip(false)
//             setAge(null);
//             setOpen(true);
//             setPart1("");
//             setPart2("");
//             setPart3("");
//             setPart4("");
//             setTimeout(() => {
//               setOpen(false);
//             }, 500);

//             setOpen(false);
//             await setOpenTable(true);
//             await setdata([...data, res.data.userDetail]);

//             await setTimeout(async () => {
//               // await toast.success("User Created SuccessFully", {
//               //   theme: "colored",
//               // });
//               Swal.fire({
//                 icon: "success",
//                 //  title: "Oops...",
//                 text: "User Created SuccessFully",
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }, 100);
//           } else {
//             setOpen(false);
//             await setTimeout(async () => {
//               // await toast.error(res.data.statusDescription.description, {
//               //   theme: "colored",
//               // });
//               Swal.fire({
//                 icon: "error",
//                 title: "Oops...",
//                 text: res.data.statusDescription.description,
//                 // footer: '<a href="">Why do I have this issue?</a>'
//               });
//             }, 100);
//           }
//         } catch (error) {
//           setOpen(false);
//           // console.log(error);
//           await setTimeout(async () => {
//             // await toast.error("Something went wrong", {
//             //   theme: "colored",
//             // });
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Something went wrong",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }, 100);
//         }
//       }
//     },
//   });
// //  ..................................TPS Get API..................................................//
// async function TpsGet() {
//   setdata([]);
//   setHideSkeleton1(true);
//   try {
//     // setOpen(true);
//     const result = await common_axios.get(
//       `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/system-tps`
//     );

//     // console.log("result get api.........", result);

//     if (result.data.statusDescription.statusCode == 200) {
//       setOpen(false);
//       await setMaxLimit(result.data.systemTpsModel);
//       // await formik.setFieldValue("tpsLimit", result.data.systemTpsModel.tpsLimit);
//       setHideSkeleton1(false);
//     } else {
//       // setOpen();
//       setHideSkeleton1(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: result.data.statusDescription.statusdescription,
//       });
//     }
//   } catch (error) {
//     // setOpen();
//     setHideSkeleton1(false);

//     Swal.fire({
//       icon: "error",
//       title: "Oops...",
//       text: "Please Check Your Network",
//       // footer: '<a href="">Why do I have this issue?</a>'
//     });
//   }
// }
// useEffect(() => {
//   TpsGet();
// }, []);




//   async function UsernameCheck() {
//     try {
//       setHideSkeleton(true);
//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API}/admin/v1/check/username`,
//         {
//           userName: formik?.values?.userName,
//         }
//       );
//       if (res.data.statusDescription.statusCode == 200) {
//         // setOpen(false);
//         setCheckUsernameError("");
//         setHideSkeleton(false);
//       }
//       // else if (res.data.statusDescription.statusCode == 202) {
//       //   toast.error(res.data.statusDescription.description, {
//       //     theme: "colored",
//       //   });
//       // }
//       else {
//         setHideSkeleton(false);
//         // setOpen(false);
//         // toast.error(res.data.statusDescription.description,{
//         //   // toastId: customId1,
//         //   theme: "colored",

//         // });
//         setCheckUsernameError(res.data.statusDescription.description);
//       }
//     } catch (error) {
//       setHideSkeleton(false);
//       // setOpen(false);
//       // toast.error("Please Check Your Network", {
//       //   // toastId: customId1,
//       //   theme: "colored",
//       // });
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }
//   const [password, setPassword] = useState("");

//   // const generatePassword = () => {
//   //   const passwordLength = 8; // Change this to adjust the length of the password
//   //   const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+{}[]|;:,.<>?';
//   //   let newPassword = '';

//   //   for (let i = 0; i < passwordLength; i++) {
//   //     const randomIndex = Math.floor(Math.random() * characters.length);
//   //     newPassword += characters[randomIndex];
//   //   }

//   //   setPassword(newPassword);
//   // }

//   function generatePassword() {
//     // alert("hii")
//     const lowercase = "abcdefghijklmnopqrstuvwxyz";
//     const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//     const numbers = "0123456789";
//     const special = "!@#$%^&*()_+~`|}{[]:;?><,./-=";
//     let password = "";
//     let length = 12;
//     for (let i = 0; i < length; i++) {
//       const randomm = Math.floor(Math.random() * 4);
//       if (randomm === 0) {
//         password += lowercase[Math.floor(Math.random() * lowercase.length)];
//       } else if (randomm === 1) {
//         password += uppercase[Math.floor(Math.random() * uppercase.length)];
//       } else if (randomm === 2) {
//         password += numbers[Math.floor(Math.random() * numbers.length)];
//       } else {
//         password += special[Math.floor(Math.random() * special.length)];
//       }
//     }
//     // return password;
//     setPassword(password);
//   }

//   useEffect(() => {
//     formik.setFieldValue("password", password);
//   }, [password]);

//   return (
//     <>
//       <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//           // onClick={handleClose}
//         >
//           <Loader/>
//         </Backdrop>
//         <ThemeProvider theme={theme}>
//           <div className="container-fluid">
//             <div className="card">
//               <div className="card-header p-3 pt-2">
//                 <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
//                   <PersonIcon
//                     style={{
//                       color: "white",
//                       fontSize: "27px",
//                     }}
//                   />
//                 </div>
//                 <div className="pt-1">
//                   <p
//                     className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
//                     style={{ marginLeft: "70px" }}
//                   >
//                     Create User
//                   </p>
//                   <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
//                     Field(s) marked with{" "}
//                     <span className="text-danger fw-bold">*</span> are
//                     mandatory.
//                   </p>
//                 </div>
//               </div>
//               <div className="card-body">
//                 <div className="card shadow-none border bg_blue">
//                   <span className="badge rounded-pill bg-primary mt-n3 ms-5">
//                     Details
//                   </span>

//                   <div className="card-body text-lg-start text-center "
//                    id="ip_button"
//                   >
//                     <form
//                       onSubmit={formik.handleSubmit}
//                       className="row g-3 needs-validation"
//                       novalidate
//                     >
//                       <div className="col-md-3" id="tool_tip">
//                         <TextField
//                           required
//                           className="w-100"
//                           label="Name"
//                           name="name"
//                           variant="outlined"
//                           size="small"
//                           type="text"
//                           InputProps={{
//                             endAdornment: (
//                               <InputAdornment position="end">
//                                 <Tooltip
//                                   title="Name"
//                                   placement="top"
//                                   arrow
//                                   sx={{ color: "#85CBF2" }}
//                                 >
//                                   <InfoIcon />
//                                 </Tooltip>
//                               </InputAdornment>
//                             ),
//                           }}
//                           value={formik.values.name}
//                           onChange={formik.handleChange}
//                           error={
//                             formik.touched.name && Boolean(formik.errors.name)
//                           }
//                           helperText={formik.touched.name && formik.errors.name}
//                         />
//                       </div>
//                       <div className="col-md-3">
//                         <TextField
//                           // required
//                           className="w-100"
//                           label="E-Mail"
//                           name="email"
//                           variant="outlined"
//                           size="small"
//                           type="email"
//                           InputProps={{
//                             endAdornment: (
//                               <InputAdornment position="end">
//                                 <Tooltip
//                                   title="E-Mail"
//                                   placement="top"
//                                   arrow
//                                   sx={{ color: "#85CBF2" }}
//                                 >
//                                   <InfoIcon />
//                                 </Tooltip>
//                               </InputAdornment>
//                             ),
//                           }}
//                           value={formik.values.email}
//                           onChange={formik.handleChange}
//                           error={
//                             formik.touched.email && Boolean(formik.errors.email)
//                           }
//                           helperText={
//                             formik.touched.email && formik.errors.email
//                           }
//                         />
//                       </div>
//                       {/* <div className="col-md-1">
// <input
//   disabled
//   value="+222"
// />
//                       </div> */}
//                       <div className="col-md-3" id="inp_merge">
//                       <div className="d-flex">
//                       <input className="inpt_width"
//   disabled
//   value="+222"
// />
//                         <TextField
//                           required
//                           className="w-100"
//                           label="Phone Number"
//                           name="phoneNumber"
//                           variant="outlined"
//                           size="small"
//                           type="string"
//                           InputProps={{
//                             endAdornment: (
//                               <InputAdornment position="end">
//                                 <Tooltip
//                                   title="Phone Number"
//                                   placement="top"
//                                   arrow
//                                   sx={{ color: "#85CBF2" }}
//                                 >
//                                   <InfoIcon />
//                                 </Tooltip>
//                               </InputAdornment>
//                             ),
//                           }}
//                           value={formik.values.phoneNumber}
//                           onChange={formik.handleChange}
//                           error={
//                             formik.touched.phoneNumber &&
//                             Boolean(formik.errors.phoneNumber)
//                           }
//                           helperText={
//                             formik.touched.phoneNumber &&
//                             formik.errors.phoneNumber
//                           }
//                           onInput={(e) => {
//                           // e.target.value = Math.max(0, parseInt(e.target.value))
//                           //   .toString()
//                           //   .slice(0, 8);
//                           e.target.value = e.target.value.slice(0, 8);
//                         }}


//                         onKeyPress={(event) => {
//                           const keyCode = event.keyCode || event.which;

//                           if (
//                             (keyCode >= 48 && keyCode <= 57) ||
//                             keyCode == 13
//                           ) {
//                             seterror(false);
//                           } else {
//                             event.preventDefault();
//                             seterror(true);
//                           }
//                         }}
//                           // inputProps={{ maxLength: 9999999999 }}
//                         />
//                         </div>

//                         <div className="row">
//                     {error == true ? (
//                       <>
//                         <p style={{ color: "red" }}>
//                           Only Numbers Are Allowed!!
//                         </p>
//                       </>
//                     ) : (
//                       <></>
//                     )}
//                   </div>
//                       </div>
//                       <div className="col-md-3">
//                         <FormControl required fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Status
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={statusDropDown}
//                             onChange={handleChange4}
//                             autowidth
//                             label="Status"
//                           >
//                             <MenuItem value="1">Activate</MenuItem>
//                             <MenuItem value="0">Deactivate</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </div>
//                       <div className="col-md-3">
//                         {hideSkeleton == true ? (
//                           <>
//                             {" "}
//                             <Box sx={{ width: 280 }}>
//                               <Skeleton />

//                               <Skeleton animation="wave" />
//                               {/* <Skeleton animation={false} /> */}
//                             </Box>
//                           </>
//                         ) : (
//                           <>
//                             {" "}
//                             <TextField
//                               required
//                               className="w-100"
//                               label="Username"
//                               name="userName"
//                               variant="outlined"
//                               size="small"
//                               type="text"
//                               // error={
//                               //                 selectedUserDetailApprove.regExprTON >
//                               //                   127 ||
//                               //                 selectedUserDetailApprove.regExprTON <
//                               //                   0
//                               //               }
//                               //               helperText={
//                               //                 selectedUserDetailApprove.regExprTON >
//                               //                   127 ||
//                               //                 selectedUserDetailApprove.regExprTON <
//                               //                   0
//                               //                   ? "Character range should be from 0-127"
//                               //                   : null
//                               //               }
//                               InputProps={{
//                                 endAdornment: (
//                                   <InputAdornment position="end">
//                                     {removeTooltip == false ? (
//                                       <>
//                                         <Tooltip
//                                           title="Username"
//                                           placement="top"
//                                           arrow
//                                           sx={{ color: "#85CBF2" }}
//                                         >
//                                           <InfoIcon />
//                                         </Tooltip>
//                                       </>
//                                     ) : (
//                                       <>
//                                         {checkUsernameError == "" ? (
//                                           <>
//                                             <CheckCircleIcon
//                                               style={{
//                                                 // backgroundColor: "green",
//                                                 // color: "white",
//                                                 // fontWeight: "300",
//                                                 // fontSize: "15px",
//                                                 // height: " 25px",
//                                                 color: "green",
//                                                 fontSize: "20px",
//                                                 borderRadius: "15px",
//                                                 backgroundColor: "#ffff",
//                                               }}
//                                             />
//                                           </>
//                                         ) : (
//                                           <>
//                                             <CancelIcon
//                                               style={{
//                                                 color: "red",
//                                                 fontSize: "20px",
//                                                 borderRadius: "15px",
//                                                 backgroundColor: "#ffff",
//                                               }}
//                                             />
//                                           </>
//                                         )}
//                                       </>
//                                     )}
//                                   </InputAdornment>
//                                 ),
//                               }}
//                               value={formik.values.userName}
//                               onBlur={() => {
//                                 UsernameCheck();
//                                 setremoveTooltip(true);
//                               }}
//                               onChange={formik.handleChange}
//                               error={
//                                 (formik.touched.userName ||
//                                   checkUsernameError) &&
//                                 Boolean(
//                                   formik.errors.userName || checkUsernameError
//                                 )
//                               }
//                               helperText={
//                                 formik.touched.userName ||
//                                 (checkUsernameError &&
//                                   formik.errors.userName) ||
//                                 checkUsernameError
//                               }
//                             />
//                           </>
//                         )}
//                       </div>
//                       <div className="col-md-3 psd_w">
//                         <TextField
//                           required
//                           className="w-100"
//                           label="Password"
//                           name="password"
//                           type={showPassword ? "text" : "password"}
//                           variant="outlined"
//                           size="small"
//                           value={formik.values.password}
//                           // value={password
//                           // }
//                           onChange={formik.handleChange}
//                           error={
//                             formik.touched.password &&
//                             Boolean(formik.errors.password)
//                           }
//                           helperText={
//                             formik.touched.password && formik.errors.password
//                           }
//                           InputProps={{
//                             // <-- This is where the toggle button is added.
//                             endAdornment: (
//                               <InputAdornment position="end">
//                                 <IconButton
//                                   aria-label="toggle password visibility"
//                                   onClick={handleClickShowPassword}
//                                   onMouseDown={handleMouseDownPassword}
//                                 >
//                                   {showPassword ? (
//                                     <VisibilityIcon sx={{ color: "#85CBF2" }} />
//                                   ) : (
//                                     <VisibilityOffIcon
//                                       sx={{ color: "#85CBF2" }}
//                                     />
//                                   )}
//                                 </IconButton>
//                                 <button
//                                   class="btn bg-gradient-primary w-auto m-0 "
//                                   type="button"
//                                   onClick={generatePassword}
//                                   style={{ padding: "4px" }}
//                                 >
//                                   <KeyIcon style={{ fontSize: "1.2rem" }} />
//                                   {/* Generate Password   */}
//                                   {/* <KeyIcon/>
// <LockIcon/> */}
//                                   {/* <PasswordIcon/> */}
//                                 </button>
//                               </InputAdornment>
//                             ),
//                           }}
//                         />
                        
//                       </div>
              
//                       <div className="col-md-3">
//                         <FormControl required fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Assigned Role
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={age}
//                             onChange={handleChange}
//                             autowidth
//                             label="Assigned Role"
//                           >
//                             <MenuItem value="User">User</MenuItem>
//                             {/* <MenuItem value="Reseller">Reseller</MenuItem> */}
//                           </Select>
//                         </FormControl>
//                       </div>

//                       <div className="col-md-3">
//                         <FormControl required fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Filter Message
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={filterDropDown}
//                             onChange={handleChange1}
//                             autowidth
//                             label="Filter Message"
//                           >
//                             <MenuItem value="1">Yes</MenuItem>
//                             <MenuItem value="0">No</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </div>

//                       <div className="col-md-3">
//                         <FormControl required fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Allow Trans Sender Names from Portal
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={transactionalDropDown}
//                             onChange={handleChange2}
//                             autowidth
//                             label="llow Trans Sender Names from Portal"
//                           >
//                             <MenuItem value="1">Yes</MenuItem>
//                             <MenuItem value="0">No</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </div>

//                       <div className="col-md-3">
//                         <FormControl required fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Delivery Report Request
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={DeliveryReportDropDown}
//                             onChange={handleChange3}
//                             autowidth
//                             label="Delivery Report Request"
//                           >
//                             <MenuItem value="1">Yes</MenuItem>
//                             <MenuItem value="0">No</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </div>
                      
//                       <div className="col-md-3">
//                         <FormControl required fullWidth size="small">
//                           <InputLabel id="demo-simple-select-autowidth-label">
//                             Mask Number
//                           </InputLabel>
//                           <Select
//                             labelId="demo-simple-select-autowidth-label"
//                             id="demo-simple-select-autowidth"
//                             value={maskNumberDropDown}
//                             onChange={handleChange5}
//                             autowidth
//                             label="Mask Number"
//                           >
//                             <MenuItem value="1">Yes</MenuItem>
//                             <MenuItem value="0">No</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </div>

//                       <div className="col-md-3" id="tool_tip">
                     
//                         <TextField
//                           required
//                           className="w-100"
//                           label="TPS Limit"
//                           name="tpsLimit"
//                           variant="outlined"
//                           size="small"
//                           type="text"
//                           InputProps={{
//                             endAdornment: (
//                               <InputAdornment position="end">
//                                 <Tooltip
//                                   title="TPS Limit"
//                                   placement="top"
//                                   arrow
//                                   sx={{ color: "#85CBF2" }}
//                                 >
//                                   <InfoIcon />
//                                 </Tooltip>
//                               </InputAdornment>
//                             ),
//                           }}
//                           value={formik.values.tpsLimit}
//                           onChange={formik.handleChange}
//                           error={
//                             formik.touched.tpsLimit && Boolean(formik.errors.tpsLimit)
//                           }
//                           helperText={formik.touched.tpsLimit && formik.errors.tpsLimit} 
//                           onInput={(e) => {
//                           // e.target.value = Math.max(0, parseInt(e.target.value))
//                           //   .toString()
//                           //   .slice(0, 8);
//                           let Num = maxLimit?.tpsLimit?.toString()
//                           e.target.value = e.target.value.slice(0, Num?.length);
//                         }}
//                         onKeyPress={(event) => {
//                           const keyCode = event.keyCode || event.which;

//                           if (
//                             (keyCode >= 48 && keyCode <= 57) ||
//                             keyCode == 13
//                           ) {
//                             // seterror(false);
//                             if(Number(formik.values.tpsLimit) > Number(maxLimit?.tpsLimit )){
//                                 seterror(true)
//                             }
//                             else{
//                               seterror(false)
//                             }
//                           } else {
//                             event.preventDefault();
//                             seterror(true);
//                           }
//                         }}
//                         />
// <div className="mt-2">
//                         {Number(formik?.values?.tpsLimit) >
//                           Number(maxLimit?.tpsLimit) ? (
//                           <>
//                             <p style={{ fontSize: "12px", color: "#d32f2f" }}>
//                               TPS Limit should be less than or equal to {`${maxLimit?.tpsLimit}`}
                              
//                               {/* less than or equal to SystemTps
//                               Limit */}
//                             </p>
                          
//                           </>
//                         )
                        
//                         : Number(formik?.values?.tpsLimit)===0 ? (<>
//                           <p style={{ fontSize: "12px", color: "#d32f2f" }}>
//                               TPS Limit should not be 0
//                             </p>
//                         </>):(<></>)
//                         }
//                       </div>
//                       <label className="d-block mb-0 mt-2" style={{marginTop:'-8px', color: "#d32f2f",}}>
                      
//                                           <span style={{ color: "#d32f2f" }}>
//                                             *
//                                           </span>
//                                           (TPS Limit should be {`${maxLimit?.tpsLimit}`})
                                        
//                                         </label>
//                       </div>
//                                       <div className="col-md-3">
//                                         <label className="d-block mb-0" style={{marginTop:'-8px'}}>
//                                         WhiteListing IP Address{" "}
//                                           <span style={{ color: "red" }}>
//                                             *
//                                           </span>
//                                         </label>
//                                         <div className="row alignDivnew">
//                                           <div className="col d-flex align-items-center">
//                                             <input
//                                               // type="number"
//                                               id="part1"
//                                               className="impMargin1"
//                                               required
//                                               min={0}
//                                               max={255}
//                                               ref={inputRef1}
//                                               value={part1}
//                                               onChange={(event) =>
//                                                 handleInputChange(
//                                                   event,
//                                                   setPart1
//                                                 )
//                                               }
//                                             />
//                                           </div>
//                                           <div class="col col_1">
//                                             <span class="spanMargin m-0">
//                                               .
//                                             </span>
//                                           </div>
//                                           <div className="col d-flex align-items-center">
//                                             <input
//                                               // type="number"
//                                               id="part2"
//                                               className="impMargin2"
//                                               required
//                                               min={0}
//                                               max={255}
//                                               value={part2}
//                                               ref={inputRef2}
//                                               onChange={(event) =>
//                                                 handleInputChange2(
//                                                   event,
//                                                   setPart2
//                                                 )
//                                               }
//                                             />
//                                           </div>
//                                           <div class="col col_1">
//                                             <span class="spanMargin m-0">
//                                               .
//                                             </span>
//                                           </div>
//                                           <div className="col d-flex align-items-center">
//                                             <input
//                                               // type="number"
//                                               id="part3"
//                                               className="impMargin2"
//                                               required
//                                               min={0}
//                                               max={255}
//                                               value={part3}
//                                               ref={inputRef3}
//                                               onChange={(event) =>
//                                                 handleInputChange3(
//                                                   event,
//                                                   setPart3
//                                                 )
//                                               }
//                                             />
//                                           </div>
//                                           <div class="col col_1">
//                                             <span class="spanMargin m-0">
//                                               .
//                                             </span>
//                                           </div>
//                                           <div className="col d-flex align-items-center">
//                                             <input
//                                               // type="number"
//                                               id="part4"
//                                               className="impMargin2"
//                                               required
//                                               min={0}
//                                               max={255}
//                                               value={part4}
//                                               ref={inputRef4}
//                                               onChange={(event) =>
//                                                 handleInputChange4(
//                                                   event,
//                                                   setPart4
//                                                 )
//                                               }
//                                             />
//                                           </div>
//                                     {/* <div class="row">
//                                     <button
//                           style={{ marginLeft: "6px" }}
//                           type="button"
//                         onClick={()=>{
//                           setPart1("*")
//                           setPart2("*")
//                           setPart3("*")
//                           setPart4("*")
                        
//                         }}
//                           className="btn bg-gradient-secondary "
//                         >
//                           Reset
//                           <i className="material-icons opacity-10">
//                             settings_backup_restore
//                           </i>
//                         </button>
//                                     </div> */}
//                                         </div>
//                                       </div>

//                       {/* <div className="row">
                                  
//                                     </div> */}
//                       {/* <div class="row"> */}
//                         <div class="col-md-12">
//                           <div class="input-group input-group-outline ">
//                             <label
//                               for="exampleFormControlSelect1"
//                               class="ms-0 mt-2 mb-0 d-inline-block me-3"
//                             >
//                               Secure(Encrypt) Message
//                               <span class="text-danger fw-bold">*</span>
//                             </label>

//                             <SecureMessageRadioButton
//                               parentCallback={callbackSecureMesage}
//                             />
                         
//                           </div>
//                         </div>
//                         <div class="col-md-3 mt-3">
//                               {secureMessage == "None" && (
//                                 <>
//                                   <div>
//                                     {/* <span>
//                                       None(Default) means No additional action
//                                       applied
//                                     </span> */}
//                                   </div>
//                                 </>
//                               )}
//                               {/* {secureMessage == "Mask Number" && (
//                                 <>
//                                   <div>
//                                     <span>
//                                       Mask Number: All the numbers in the
//                                       message will be masked with *
//                                     </span>
//                                   </div>
//                                 </>
//                               )} */}
//                               {secureMessage == "Hashing" && (
//                                 <>
//                                   <div>
//                                     {/* <span>
//                                       Hashing: Messages will be hashed using the
//                                       secure SHA256 Algorithm and stored in
//                                       database. Actual message cannot be
//                                       retieved in this case.
//                                     </span> */}
//                                   </div>
//                                 </>
//                               )}
//                               {secureMessage == "DES Encryption" && (
//                                 <>
                                  
//                                     {/* <div className="col-md-3 mt-3"> */}
//                                       <TextField
//                                         required
//                                         className="w-100"
//                                         label="Secret Key"
//                                         name="encryptedMessage"
//                                         variant="outlined"
//                                         size="small"
//                                         type="text"
//                                         InputProps={{
//                                           endAdornment: (
//                                             <InputAdornment position="end">
//                                               <Tooltip
//                                                 title="Secret Key"
//                                                 placement="top"
//                                                 arrow
//                                                 sx={{ color: "#85CBF2" }}
//                                               >
//                                                 <InfoIcon />
//                                               </Tooltip>
//                                             </InputAdornment>
//                                           ),
//                                         }}
//                                         value={formik.values.encryptedMessage}
//                                         onChange={formik.handleChange}
//                                         error={
//                                           formik.touched.encryptedMessage &&
//                                           Boolean(
//                                             formik.errors.encryptedMessage
//                                           )
//                                         }
//                                         helperText={
//                                           formik.touched.encryptedMessage &&
//                                           formik.errors.encryptedMessage
//                                         }
//                                       />
//                                     {/* </div> */}
                                  
//                                 </>
//                               )}
//                               {secureMessage == "AES256 Encryption" && (
//                                 <>
//                                   <div>
//                                     {/* <span>
//                                       Messages will be encrypted using the
//                                       latest AES256 Encryption Algorithm using a
//                                       secret key(32 Characters) and the account
//                                       password
//                                     </span> */}
//                                     {/* <div className="col-md-3 mt-3"> */}
//                                       <TextField
//                                         required
//                                         className="w-100"
//                                         label="Secret Key"
//                                         name="encryptedMessage"
//                                         variant="outlined"
//                                         size="small"
//                                         type="text"
//                                         InputProps={{
//                                           endAdornment: (
//                                             <InputAdornment position="end">
//                                               <Tooltip
//                                                 title="Secret Key"
//                                                 placement="top"
//                                                 arrow
//                                                 sx={{ color: "#85CBF2" }}
//                                               >
//                                                 <InfoIcon />
//                                               </Tooltip>
//                                             </InputAdornment>
//                                           ),
//                                         }}
//                                         value={formik.values.encryptedMessage}
//                                         onChange={formik.handleChange}
//                                         error={
//                                           formik.touched.encryptedMessage &&
//                                           Boolean(
//                                             formik.errors.encryptedMessage
//                                           )
//                                         }
//                                         helperText={
//                                           formik.touched.encryptedMessage &&
//                                           formik.errors.encryptedMessage
//                                         }
//                                       />
//                                     </div>
//                                   {/* </div> */}
//                                 </>
//                               )}
//                               {secureMessage == "Do Not Store" && (
//                                 <>
//                                   <div>
//                                     {/* <span>
//                                       Do Not Store: Messages will not be stored
//                                       in database
//                                     </span> */}
//                                   </div>
//                                 </>
//                               )}
//                             </div>
//                       {/* </div> */}
//                       {/* <div class="row mt-3">
//                         <form onSubmit={handleSubmit}>
//                           <div className="ip_8">
//                             <label htmlFor="part1">IP Address:</label>
//                             <div className="row alignDivnew">
//                               <div className="col-md-1 d-flex align-items-center">
//                                 <input
                               
//                                   id="part1"
//                                   className="impMargin1"
//                                   required
//                                   min={0}
//                                   max={255}
//                                   ref={inputRef1}
//                                   value={part1}
//                                   onChange={(event) =>
//                                     handleInputChange(event, setPart1)
//                                   }
//                                 />
//                                 <span>.</span>
//                               </div>
//                               <div className="col-md-1 d-flex align-items-center">
//                                 <input
//                                   id="part2"
//                                   className="impMargin2"
//                                   min={0}
//                                   max={255}
//                                   value={part2}
//                                   ref={inputRef2}
//                                   onChange={(event) =>
//                                     handleInputChange2(event)
//                                   }
//                                 />
//                                 <span>.</span>
//                               </div>
//                               <div className="col-md-1 d-flex align-items-center">
//                                 <input
//                                   id="part3"
//                                   className="impMargin2"
//                                   min={0}
//                                   max={255}
//                                   value={part3}
//                                   ref={inputRef3}
//                                   onChange={(event) =>
//                                     handleInputChange3(event)
//                                   }
//                                 />
//                                 <span>.</span>
//                               </div>
//                               <div className="col-md-1 d-flex align-items-center">
//                                 <input
//                                   // type="number"
//                                   id="part4"
//                                   className="impMargin2"
//                                   min={0}
//                                   max={255}
//                                   value={part4}
//                                   ref={inputRef4}
//                                   onChange={(event) =>
//                                     handleInputChange4(event)
//                                   }
//                                 />
//                               </div>
//                             </div>
//                           </div>
                          
//                         </form>
//                       </div> */}
//                       <div className="d-flex justify-content-between">
//                         <button
//                           style={{ marginLeft: "6px" }}
//                           type="button"
//                           onClick={formik.resetForm}
//                           className="btn resetBtn_UP"
//                         >
//                           Reset
//                             {/* <i className="material-icons opacity-10">
//                               settings_backup_restore
//                             </i> */}
//                         </button>

//                         <button
//                           type="submit"
//                           className="btn bg-gradient-primary "
//                           disabled={checkUsernameError != "" ||
//                           Number(formik?.values?.tpsLimit) >
//                           Number(maxLimit?.tpsLimit) ||
//                           Number(formik?.values?.tpsLimit)===0 
//                           } 
//                         >
//                           Submit
//                           {/* <i className="material-icons opacity-10">
//                             arrow_right_alt
//                           </i> */}
//                         </button>

//                       </div>

//                       {/* <button type="button" className="btn btn-primary">
//               Save
//             </button> */}
//                     </form>
//                   </div>
//                 </div>


//                 <div className="d-flex mt-3 me-3 mb-3 justify-content-center">
//                   <div className="main_box up_buttonStyle px-4">
                   
//                     <Link
//                       to="/dashboard/ViewUsers"

//                     >
//                       <p className="fw-bold text-white">View All Users</p>
//                     </Link>
//                   </div>
//                 </div>

//                 {/* <div className="text-end mt-2">
//                   <p> Want to See Account Holders </p>
//                   <Link
//                     to="/dashboard/ViewUsers"
//                     style={{ color: "#63B7E6", marginLeft: "30px" }}
//                   >
//                     <span>View All Users !!!</span>
//                   </Link>
//                 </div> */}
//               </div>

//               {openTable == true && (
//                 <>
//                   {data.length > 0 && (
//                     <>
//                       <div className="card-body">
//                         <div className="container-fluid p-0">
//                           <div className="card shadow-none border bg_blue mt-5">
//                             <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
//                               Recently Added
//                             </span>
//                             <div className="p-4">
//                               {/* <div className="d-flex justify-content-between my-3">
//                                 <select
//                                   value={pageSize}
//                                   className="dropdown"
//                                   onChange={(e) => {
//                                     setPageSize(Number(e.target.value));
//                                   }}
//                                 >
//                                   {[10, 25, 50].map((value, i) => {
//                                     return (
//                                       <option
//                                         className="dropdown-menu"
//                                         aria-labelledby="dropdownMenuButton1"
//                                         value={value}
//                                         key={value}
//                                       >
//                                         {" "}
//                                         Show {value}
//                                       </option>
//                                     );
//                                   })}
//                                 </select>
//                               </div> */}
//                               <table
//                                 {...getTableProps()}
//                                 id="example"
//                                 className="table table-striped table-bordered dataTable table-sm mt-3"
//                                 style={{ width: "100%" }}
//                               >
//                                 <thead>
//                                   {headerGroups.map((headerGroup) => (
//                                     <tr {...headerGroup.getHeaderGroupProps()}>
//                                       {headerGroup.headers.map((column) => (
//                                         <th
//                                           {...column.getHeaderProps(
//                                             column.getSortByToggleProps()
//                                           )}
//                                           className="text-center width_2"
//                                         >
//                                           {column.render("Header")}
//                                           <span>
//                                             {column.isSorted
//                                               ? column.isSortedDesc
//                                                 ? "↑"
//                                                 : "↓"
//                                               : ""}
//                                           </span>

//                                           {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
//                                         </th>
//                                       ))}
//                                     </tr>
//                                   ))}
//                                 </thead>
//                                 <tbody {...getTableBodyProps()}>
//                                   {/* {rows.map((row) => {
// prepareRow(row);
// return (
// <tr {...row.getRowProps()}>
//  {row.cells.map((cell) => {
//    return (
//      <td {...cell.getCellProps()} className="text-center">
//        {cell.render("Cell")}
//      </td>
//    );
//  })}
// </tr>
// );
// })} */}

//                                   {page.map((row) => {
//                                     prepareRow(row);
//                                     return (
//                                       <tr {...row.getRowProps()}>
//                                         {row.cells.map((cell) => {
//                                           return (
//                                             <td
//                                               {...cell.getCellProps()}
//                                               className="text-center"
//                                             >
//                                               {cell.render("Cell")}
//                                             </td>
//                                           );
//                                         })}
//                                       </tr>
//                                     );
//                                   })}
//                                 </tbody>
//                                 {/* <tfoot>
// {footerGroups.map((footerGroup) => (
// <tr {...footerGroup.getFooterGroupProps()}>
// {footerGroup.headers.map((column) => (
//  <td className="text-center" {...column.getFooterProps}>
//    {column.render("Footer")}
//  </td>
// ))}
// </tr>
// ))}
// </tfoot> */}
//                               </table>
//                               {/* <div className="d-flex justify-content-between">
//                                 <div>
//                                   <span>
//                                     Page:
//                                     <strong>
//                                       {pageIndex + 1} of {pageOptions.length}
//                                     </strong>
//                                   </span>
//                                 </div>

//                                 <div id="nikhil">
 
//                                   <button
//                                     className="btn btn_primary m-0"
//                                     type="button"
//                                     disabled={!canPreviousPage}
//                                     onClick={() => {
//                                       previousPage();
//                                     }}
//                                   >
//                                     Prev
//                                   </button>

//                                   <button
//                                     className="btn btn_primary m-0"
//                                     type="button"
//                                     disabled={!canNextPage}
//                                     onClick={() => {
//                                       nextPage();
//                                     }}
//                                   >
//                                     Next
//                                   </button>
//          </div>
//                               </div> */}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </ThemeProvider>
//       </main>
//     </>
//   );
// }



import {
  Backdrop,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";
import { common_axios } from "../../../../App";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Loader from "../../../../components/Loader";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import SecureMessageRadioButton from "./SecureMessageRadioButton";
import KeyIcon from "@mui/icons-material/Key";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import CancelIcon from "@mui/icons-material/Cancel";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { max } from "date-fns";
export default function AddReseller() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [open, setOpen] = useState(false);
  const [removeTooltip, setremoveTooltip] = useState(false);
  const [age, setAge] = React.useState("User");
  const [filterDropDown, setFilterDropDown] = React.useState("0");
  const [transactionalDropDown, setTransactionalDropDown] = React.useState("0");
  const [DeliveryReportDropDown, setDeliveryReportDropDown] =
    React.useState("0");
  const [statusDropDown, setStatusDropDown] = React.useState("1");
  const [maskNumberDropDown, setMaskNumberDropDown] = React.useState("0");

  const [secureMessage, setSecureMessage] = useState("None or Default");
  const [textField, setTextField] = useState("");
  const [openTable, setOpenTable] = useState(false);
  const [verify, setVerify] = useState("");
  const [documents, setDocuments] = useState("");
  const [user, setUser] = useState("");
  const [data, setdata] = useState([]);
  const [maxLimit, setMaxLimit] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [variantName, setVariantName] = React.useState([]);
  const [variantNameEmpty, setVariantNameEmpty] = React.useState();
  const [checkUsernameError, setCheckUsernameError] = React.useState("");
  const [error, seterror] = useState(false);
  const [hideSkeleton1, setHideSkeleton1] = useState();

  // console.log("uioo", error);
  const [Ip, setIp] = useState("");
  const [part1, setPart1] = useState("");
  const [part2, setPart2] = useState("");
  const [part3, setPart3] = useState("");
  const [part4, setPart4] = useState("");
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  // console.log("oip", Ip);
  const handleInputChange = (event) => {
    const value = event.target.value;
    if ((value >= 0 && value <= 255) || value == "*") {
      setPart1(value);
    }
  };
  const handleInputChange2 = (event) => {
    const value = event.target.value;
    if ((value >= 0 && value <= 255) || value == "*") {
      setPart2(value);
    }
  };
  const handleInputChange3 = (event) => {
    const value = event.target.value;
    if ((value >= 0 && value <= 255) || value == "*") {
      setPart3(value);
    }
  };
  const handleInputChange4 = (event) => {
    const value = event.target.value;
    if ((value >= 0 && value <= 255) || value == "*") {
      setPart4(value);
    }
  };

  useEffect(() => {
    if (part1.length == 3 || part1 == "*") {
      inputRef2.current.focus();
    }
  }, [part1]);

  useEffect(() => {
    if (part2.length == 3 || part2 == "*") {
      inputRef3.current.focus();
    }
  }, [part2]);

  useEffect(() => {
    if (part3.length == 3 || part3 == "*") {
      inputRef4.current.focus();
    }
  }, [part3]);

  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log("Submitted:", part1, part2, part3, part4);
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleChange1 = (event) => {
    setFilterDropDown(event.target.value);
  };
  const handleChange2 = (event) => {
    setTransactionalDropDown(event.target.value);
  };
  const handleChange3 = (event) => {
    setDeliveryReportDropDown(event.target.value);
  };
  const handleChange4 = (event) => {
    setStatusDropDown(event.target.value);
  };
  const handleChange5 = (event) => {
    setMaskNumberDropDown(event.target.value);
  };

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   Footer: "Id",
      //   accessor: "uid",
      //   // Cell: (cell) => {
      //   //   console.log(resellerResponse.uid);
      //   //   return (
      //   //     // <div>
      //   //     //   {cell.row.original.roleName == "user" ? (
      //   //     //     <div>User</div>
      //   //     //   ) : (
      //   //     //     <div>Reseller</div>
      //   //     //   )}
      //   //     // </div>
      //   //     <>{resellerResponse?.uid}</>
      //   //   );
      //   // }, // accessor is the "key" in the data
      // },

      // {
      //   Header: "Id",
      //   accessor: "uid",
      //   Cell: (cell ) => (
      //    <>{cell.row.index +1}</>
      //   ),
      // },
      {
        Header: "User Name",
        Footer: "User Name",
        accessor: "username",
        // Cell: (cell) => {
        //   console.log(resellerResponse.username);
        //   return (
        //     // <div>
        //     //   {cell.row.original.roleName == "user" ? (
        //     //     <div>User</div>
        //     //   ) : (
        //     //     <div>Reseller</div>
        //     //   )}
        //     // </div>
        //     <>{resellerResponse?.username}</>
        //   );
        // }, // accessor is the "key" in the data
      },
      // {
      //   Header: "Role",
      //   Footer: "Role",
      //   accessor: "userRoleId",
      // },
      {
        Header: "Email-Id",
        Footer: "Email-Id",
        accessor: "email",
        Cell: (cell) => {
          // console.log(resellerResponse.email);
          return (
            <div>
              {cell.row.original.email ? (
                <div>{cell.row.original.email}</div>
              ) : (
                <div>N/A</div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Role",
        Footer: "Role",
        accessor: "roleName",
        // Cell: (cell) => {
        //   console.log(resellerResponse.roleName);
        //   return (
        //     // <div>
        //     //   {cell.row.original.roleName == "user" ? (
        //     //     <div>User</div>
        //     //   ) : (
        //     //     <div>Reseller</div>
        //     //   )}
        //     // </div>
        //     <>{resellerResponse?.roleName}</>
        //   );
        // },
      },
      {
        Header: "Status",
        Footer: "Status",
        accessor: "status",
        Cell: (cell) => {
          // console.log(cell.row.original.approved, cell.row.original.status);
          return (
            <>
              {cell.row.original.approved == 0 ? (
                <>
                  <div className="badge badge_8 bg-warning">Pending</div>
                </>
              ) : cell.row.original.approved == 1 ? (
                <>
                  {" "}
                  <div className="badge badge_8 bg-success">Approved</div>
                </>
              ) : (
                <>
                  {" "}
                  <div className="badge badge_8 bg-danger">Rejected</div>
                </>
              )}
            </>
          );
        },
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;
  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const callbackFunction = (childData) => {
    setVerify(childData);
  };
  const callbackFunction1 = (childData) => {
    setDocuments(childData);
  };
  const callbackFunction2 = (childData) => {
    setUser(childData);
  };
  const callbackSecureMesage = (child) => {
    setSecureMessage(child);
    // console.log("first", child);
  };
  const userId = localStorage.getItem("UserId");
  const pattern = /^[A-Za-z@#._\-0-9]+$/;

  const validationSchema = yup.object({
    password: yup
      .string("Enter Your Password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required("Password required"),
    name: yup
      .string("Enter your Name")
      .min(2, "Name should be of minimum 2 characters length")
      .required("Name is required"),

    email: yup.string().email("E-Mail must be valid").max(255),
    // .required("E-Mail  is required"),
    userName: yup
      .string("Enter Your Username")
      .min(3, "Username should be at least 3 characters long")
      .required("*Username is required")
      .matches(pattern, "Only @ _ . - # special characters are allowed"),
    
    phoneNumber: yup
      // .number("Enter your PhoneNumber")
      // .min(10000000,"Minimum length of a mobile number is 8 digits")
      // .max(
      //   100000000,
      //   "Maximum length of mobile number is 8 digits"
      // )
      .string()
      .min(8, "Minimum length of a mobile number is 8 digits")
      .max(8, "Maximum length of mobile number is 8 digits")
      //  .required("Required"),
      .required("PhoneNumber is required"),
  });
  const formik = useFormik({
    initialValues: {
      userName: "",
      phoneNumber: "",
      email: "",
      password: "",
      name: "",
      encryptedMessage: "",
      tpsLimit: "1",
      role:"User",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (secureMessage == "DES Encryption") {
        // alert("if")
        // console.log("firs5t", part1);
        // setIp(part1+"."+part2+"."+part3+"."+part4)
        try {
          setOpen(true);
          const res = await common_axios.post(`admin/v2/create/`, {
            userName: values.userName,
            password: values.password,
            name: values.name,
            email: values.email,
            phoneNumber: "222" + values.phoneNumber,
            // is2factorAuth: 0,
            // emailVerification: verify,
            // documents: [""],
            // role: age,
            role: values.role,
            userId: userId,
            // ip:Ip,
            // ip: part1 + "." + part2 + "." + part3 + "." + part4,
            ip:
              part1 != "" && part2 != "" && part3 != "" && part4 != ""
                ? part1 + "." + part2 + "." + part3 + "." + part4
                : "",
            encryptedMessage: values.encryptedMessage,
            status: statusDropDown,
            deliveryReportRequest: DeliveryReportDropDown,
            allowTransSenderName: transactionalDropDown,
            filterMessage: filterDropDown,
            tpsLimit: values.tpsLimit,
            createdUser: localStorage.getItem("usernamedisplayed"),
          });
          // console.log(res.data);
          // const status = res.data.statusDescription.statusCode;
          if (res.data.statusDescription.statusCode == 200) {
            setVariantNameEmpty([]);
            await formik.handleReset();
            setAge(null);
            setremoveTooltip(false);
            setPart1("");
            setPart2("");
            setPart3("");
            setPart4("");
            setSecureMessage();
            setOpen(true);
            setTimeout(() => {
              setOpen(false);
            }, 500);

            setOpen(false);
            await setOpenTable(true);
            await setdata([...data, res.data.userDetail]);

            await setTimeout(async () => {
              // await toast.success("User Created SuccessFully", {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "success",
                //  title: "Oops...",
                text: "User Created SuccessFully",
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          } else {
            setOpen(false);
            await setTimeout(async () => {
              // await toast.error(res.data.statusDescription.description, {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: res.data.statusDescription.description,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          }
        } catch (error) {
          setOpen(false);
          // console.log(error);
          await setTimeout(async () => {
            // await toast.error("Something went wrong", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } else if (secureMessage == "AES256 Encryption") {
        // setIp(part1+"."+part2+"."+part3+"."+part4)
        // alert("if")
        try {
          setOpen(true);
          const res = await common_axios.post(`admin/v2/create/`, {
            userName: values.userName,
            password: values.password,
            name: values.name,
            email: values.email,
            phoneNumber: "222" + values.phoneNumber,
            // is2factorAuth: 0,
            // emailVerification: verify,
            // documents: [""],

            // role: age,
            role: values.role,

            userId: userId,
            ip:
              part1 != "" && part2 != "" && part3 != "" && part4 != ""
                ? part1 + "." + part2 + "." + part3 + "." + part4
                : "",
            encryptedMessage: values.encryptedMessage,
            status: statusDropDown,
            deliveryReportRequest: DeliveryReportDropDown,
            allowTransSenderName: transactionalDropDown,
            filterMessage: filterDropDown,
            tpsLimit: values.tpsLimit,
            createdUser: localStorage.getItem("usernamedisplayed"),
          });

          // console.log(res.data);
          // const status = res.data.statusDescription.statusCode;
          if (res.data.statusDescription.statusCode == 200) {
            setVariantNameEmpty([]);
            await formik.handleReset();
            setAge(null);
            setOpen(true);
            setremoveTooltip(false);
            setPart1("");
            setPart2("");
            setPart3("");
            setPart4("");
            setTimeout(() => {
              setOpen(false);
            }, 500);

            setOpen(false);
            await setOpenTable(true);
            await setdata([...data, res.data.userDetail]);

            await setTimeout(async () => {
              // await toast.success("User Created SuccessFully", {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "success",
                //  title: "Oops...",
                text: "User Created SuccessFully",
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          } else {
            setOpen(false);
            await setTimeout(async () => {
              // await toast.error(res.data.statusDescription.description, {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: res.data.statusDescription.description,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          }
        } catch (error) {
          setOpen(false);
          // console.log(error);
          await setTimeout(async () => {
            // await toast.error("Something went wrong", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } else {
        // setIp(part1+"."+part2+"."+part3+"."+part4)
        // alert("else")
        try {
          setOpen(true);
          const res = await common_axios.post(`admin/v2/create/`, {
            userName: values.userName,
            password: values.password,
            name: values.name,
            email: values.email,
            phoneNumber: "222" + values.phoneNumber,
            // is2factorAuth: 0,
            // emailVerification: verify,
            // documents: [""],
            // role: age,
            role: values.role,
            userId: userId,
            ip:
              part1 != "" && part2 != "" && part3 != "" && part4 != ""
                ? part1 + "." + part2 + "." + part3 + "." + part4
                : "",
            encryptedMessage: secureMessage,
            status: statusDropDown,
            deliveryReportRequest: DeliveryReportDropDown,
            allowTransSenderName: transactionalDropDown,
            filterMessage: filterDropDown,
            tpsLimit: values.tpsLimit,
            createdUser: localStorage.getItem("usernamedisplayed"),
          });

          // console.log(res.data);

          // const status = res.data.statusDescription.statusCode;

          if (res.data.statusDescription.statusCode == 200) {
            setVariantNameEmpty([]);
            await formik.handleReset();
            setremoveTooltip(false);
            setAge(null);
            setOpen(true);
            setPart1("");
            setPart2("");
            setPart3("");
            setPart4("");
            setTimeout(() => {
              setOpen(false);
            }, 500);

            setOpen(false);
            await setOpenTable(true);
            await setdata([...data, res.data.userDetail]);

            await setTimeout(async () => {
              // await toast.success("User Created SuccessFully", {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "success",
                //  title: "Oops...",
                text: "User Created SuccessFully",
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          } else {
            setOpen(false);
            await setTimeout(async () => {
              // await toast.error(res.data.statusDescription.description, {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: res.data.statusDescription.description,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          }
        } catch (error) {
          setOpen(false);
          // console.log(error);
          await setTimeout(async () => {
            // await toast.error("Something went wrong", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      }
    },
  });
  //  ..................................TPS Get API..................................................//
  async function TpsGet() {
    setdata([]);
    setHideSkeleton1(true);
    try {
      // setOpen(true);
      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/system-tps`
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await setMaxLimit(result.data.systemTpsModel);
        // await formik.setFieldValue("tpsLimit", result.data.systemTpsModel.tpsLimit);
        setHideSkeleton1(false);
      } else {
        // setOpen();
        setHideSkeleton1(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      // setOpen();
      setHideSkeleton1(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    TpsGet();
  }, []);

  async function UsernameCheck() {
    try {
      setHideSkeleton(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/check/username`,
        {
          userName: formik?.values?.userName,
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        // setOpen(false);
        setCheckUsernameError("");
        setHideSkeleton(false);
      }
      // else if (res.data.statusDescription.statusCode == 202) {
      //   toast.error(res.data.statusDescription.description, {
      //     theme: "colored",
      //   });
      // }
      else {
        setHideSkeleton(false);
        // setOpen(false);
        // toast.error(res.data.statusDescription.description,{
        //   // toastId: customId1,
        //   theme: "colored",

        // });
        setCheckUsernameError(res.data.statusDescription.description);
      }
    } catch (error) {
      setHideSkeleton(false);
      // setOpen(false);
      // toast.error("Please Check Your Network", {
      //   // toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  const [password, setPassword] = useState("");

  // const generatePassword = () => {
  //   const passwordLength = 8; // Change this to adjust the length of the password
  //   const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+{}[]|;:,.<>?';
  //   let newPassword = '';

  //   for (let i = 0; i < passwordLength; i++) {
  //     const randomIndex = Math.floor(Math.random() * characters.length);
  //     newPassword += characters[randomIndex];
  //   }

  //   setPassword(newPassword);
  // }

  function generatePassword() {
    // alert("hii")
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const special = "!@#$%^&*()_+~`|}{[]:;?><,./-=";
    let password = "";
    let length = 12;
    for (let i = 0; i < length; i++) {
      const randomm = Math.floor(Math.random() * 4);
      if (randomm === 0) {
        password += lowercase[Math.floor(Math.random() * lowercase.length)];
      } else if (randomm === 1) {
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
      } else if (randomm === 2) {
        password += numbers[Math.floor(Math.random() * numbers.length)];
      } else {
        password += special[Math.floor(Math.random() * special.length)];
      }
    }
    // return password;
    setPassword(password);
  }

  useEffect(() => {
    formik.setFieldValue("password", password);
  }, [password]);

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header p-3 pt-2">
                <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                  <PersonIcon
                    style={{
                      color: "white",
                      fontSize: "27px",
                    }}
                  />
                </div>
                <div className="pt-1">
                  <p
                    className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                    style={{ marginLeft: "70px" }}
                  >
                    Create User
                  </p>
                  <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                    Field(s) marked with{" "}
                    <span className="text-danger fw-bold">*</span> are
                    mandatory.
                  </p>
                </div>
              </div>
              <div className="card-body">
                <div className="card shadow-none border bg_blue">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Details
                  </span>

                  <div
                    className="card-body text-lg-start text-center "
                    id="ip_button"
                  >
                    <form
                      onSubmit={formik.handleSubmit}
                      className="row g-3 needs-validation"
                      novalidate
                    >
                      <div className="col-md-3" id="tool_tip">
                        <TextField
                          required
                          className="w-100"
                          label="Name"
                          name="name"
                          variant="outlined"
                          size="small"
                          type="text"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="Name of User"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.name}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.name && Boolean(formik.errors.name)
                          }
                          helperText={formik.touched.name && formik.errors.name}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          // required
                          className="w-100"
                          label="E-Mail"
                          name="email"
                          variant="outlined"
                          size="small"
                          type="email"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="Please insert a valid Email id"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.email && Boolean(formik.errors.email)
                          }
                          helperText={
                            formik.touched.email && formik.errors.email
                          }
                        />
                      </div>
                      {/* <div className="col-md-1">
<input
  disabled
  value="+222"
/>
                      </div> */}
                      <div className="col-md-3" id="inp_merge">
                        <div className="d-flex">
                          <input className="inpt_width" disabled value="+222" />
                          <TextField
                            required
                            className="w-100"
                            label="Phone Number"
                            name="phoneNumber"
                            variant="outlined"
                            size="small"
                            type="string"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Tooltip
                                    title="Please enter a valid phone number"
                                    placement="top"
                                    arrow
                                    sx={{ color: "#85CBF2" }}
                                  >
                                    <InfoIcon />
                                  </Tooltip>
                                </InputAdornment>
                              ),
                            }}
                            value={formik.values.phoneNumber}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.phoneNumber &&
                              Boolean(formik.errors.phoneNumber)
                            }
                            helperText={
                              formik.touched.phoneNumber &&
                              formik.errors.phoneNumber
                            }
                            onInput={(e) => {
                              // e.target.value = Math.max(0, parseInt(e.target.value))
                              //   .toString()
                              //   .slice(0, 8);
                              e.target.value = e.target.value.slice(0, 8);
                            }}
                            onKeyPress={(event) => {
                              const keyCode = event.keyCode || event.which;

                              if (
                                (keyCode >= 48 && keyCode <= 57) ||
                                keyCode == 13
                              ) {
                                seterror(false);
                              } else {
                                event.preventDefault();
                                seterror(true);
                              }
                            }}
                            // inputProps={{ maxLength: 9999999999 }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Status
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={statusDropDown}
                            onChange={handleChange4}
                            autowidth
                            label="Status"
                          >
                            <MenuItem value="1">Activate</MenuItem>
                            <MenuItem value="0">Deactivate</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-3">
                        {hideSkeleton == true ? (
                          <>
                            {" "}
                            <Box sx={{ width: 280 }}>
                              <Skeleton />

                              <Skeleton animation="wave" />
                              {/* <Skeleton animation={false} /> */}
                            </Box>
                          </>
                        ) : (
                          <>
                            {" "}
                            <TextField
                              required
                              className="w-100"
                              label="User Name"
                              name="userName"
                              variant="outlined"
                              size="small"
                              type="text"
                              // error={
                              //                 selectedUserDetailApprove.regExprTON >
                              //                   127 ||
                              //                 selectedUserDetailApprove.regExprTON <
                              //                   0
                              //               }
                              //               helperText={
                              //                 selectedUserDetailApprove.regExprTON >
                              //                   127 ||
                              //                 selectedUserDetailApprove.regExprTON <
                              //                   0
                              //                   ? "Character range should be from 0-127"
                              //                   : null
                              //               }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    {removeTooltip == false || formik?.values?.userName === "" ? (
                                      <>
                                        <Tooltip
                                          title="Username"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        {checkUsernameError == "" ? (
                                          <>
                                            <CheckCircleIcon
                                              style={{
                                                // backgroundColor: "green",
                                                // color: "white",
                                                // fontWeight: "300",
                                                // fontSize: "15px",
                                                // height: " 25px",
                                                color: "green",
                                                fontSize: "20px",
                                                borderRadius: "15px",
                                                backgroundColor: "#ffff",
                                              }}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <CancelIcon
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                                borderRadius: "15px",
                                                backgroundColor: "#ffff",
                                              }}
                                            />
                                          </>
                                        )}
                                      </>
                                    )}
                                  </InputAdornment>
                                ),
                              }}
                              value={formik.values.userName}
                              onBlur={() => {
                                if (formik?.values?.userName !== "") {
                              UsernameCheck();
                              setremoveTooltip(true);
                            }
                              }}
                              onChange={formik.handleChange}
                              error={
                                (formik.touched.userName ||
                                  checkUsernameError) &&
                                Boolean(
                                  formik.errors.userName || checkUsernameError
                                )
                              }
                              helperText={
                                // formik.touched.userName ||
                                // (checkUsernameError &&
                                //   formik.errors.userName) ||
                                // checkUsernameError
                                formik.touched.userName && formik.errors.userName ||
                                checkUsernameError
                              }
                            />
                          </>
                        )}
                      </div>
                      <div className="col-md-3 psd_w">
                        <TextField
                          required
                          className="w-100"
                          label="Password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          variant="outlined"
                          size="small"
                          value={formik.values.password}
                          // value={password
                          // }
                          onChange={formik.handleChange}
                          error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                          }
                          helperText={

                            formik.touched.password && formik.errors.password
                          }
                          InputProps={{
                            // <-- This is where the toggle button is added.
                            endAdornment: (
                              <InputAdornment position="end">
                     
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword ? (
                                    <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                  ) : (
                                    <VisibilityOffIcon
                                      sx={{ color: "#85CBF2" }}
                                    />
                                  )}

                                </IconButton>
                                <button
                                  class="btn bg-gradient-primary w-auto m-0 "
                                  type="button"
                                  onClick={generatePassword}
                                  style={{ padding: "4px" }}
                                >
                                          <Tooltip title="System generated password">
                                          <KeyIcon style={{ fontSize: "1.2rem" }} />

                </Tooltip>
                                  {/* Generate Password   */}
                                  {/* <KeyIcon/>
<LockIcon/> */}
                                  {/* <PasswordIcon/> */}
                                </button>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>

                      <div className="col-md-3">
                        {/* <FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Assigned Role
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={age}
                            onChange={handleChange}
                            autowidth
                            label="Assigned Role"
                            disabled
                          >
                            <MenuItem value="User">User</MenuItem>
                          </Select>
                        </FormControl> */}




                        <TextField
                                          // disabled={button == false}
                                          disabled
                                          required
                                          className="w-100"
                                          label="Assigned Role"
                                          name="role"
                                          variant="outlined"
                                          size="small"
                                          type="text"
                                          value={formik.values.role}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.role &&
                                            Boolean(formik.errors.role)
                                          }
                                          helperText={
                                            formik.touched.role &&
                                            formik.errors.role
                                          }
                                        />






                        {/* <TextField
                          required
                          disabled
                          className="w-100"
                          label="Assigned Role"
                          // name="name"
                          variant="outlined"
                          size="small"
                          value={User}
                            onChange={handleChange}
                          type="text"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="Assigned Role"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
 */}









                        
                      </div>

                      <div className="col-md-3">
                        <FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Filter Message
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={filterDropDown}
                            onChange={handleChange1}
                            autowidth
                            label="Filter Message"
                          >
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                            
                           
                          </Select>
                  
                          {/* <InputAdornment position="end">
                                  <Tooltip
                                    title="Filter Message"
                                    placement="top"
                                    arrow
                                    sx={{ color: "#85CBF2" }}
                                  >
                                    <InfoIcon />
                                  </Tooltip>
                                </InputAdornment> */}
                        </FormControl>
                      </div>

                      <div className="col-md-3">
                        <FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Allow Trans Sender Names from Portal
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={transactionalDropDown}
                            onChange={handleChange2}
                            autowidth
                            label="Allow Trans Sender Names from Portal"
                          >
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-3">
                        <FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Delivery Report Request
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={DeliveryReportDropDown}
                            onChange={handleChange3}
                            autowidth
                            label="Delivery Report Request"
                          >
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-3">
                        <FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Mask Number
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={maskNumberDropDown}
                            onChange={handleChange5}
                            autowidth
                            label="Mask Number"
                          >
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-3" id="tool_tip">
                        <TextField
                          required
                          className="w-100"
                          label="TPS Limit"
                          name="tpsLimit"
                          variant="outlined"
                          size="small"
                          type="text"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title={`Please enter a value between 1 to ${maxLimit?.tpsLimit} `}
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.tpsLimit}
                          onChange={formik.handleChange}
                          error={
                            (formik.touched.tpsLimit &&
                              Boolean(formik.errors.tpsLimit)) ||
                            Number(formik.values.tpsLimit) >
                              Number(maxLimit?.tpsLimit) ||
                            Number(formik?.values?.tpsLimit) === 0
                          }
                          helperText={
                            (formik.touched.tpsLimit &&
                              formik.errors.tpsLimit) ||
                            (Number(formik.values.tpsLimit) >
                              Number(maxLimit?.tpsLimit) &&
                              `TPS Limit should be less than or equal to
                                ${maxLimit?.tpsLimit}`) ||
                            (Number(formik?.values?.tpsLimit) === 0 &&
                              "TPS limit can not be Blank.")
                          }
                          onInput={(e) => {
                            // e.target.value = Math.max(0, parseInt(e.target.value))
                            //   .toString()
                            //   .slice(0, 8);
                            let Num = maxLimit?.tpsLimit?.toString();
                            e.target.value = e.target.value.slice(
                              0,
                              Num?.length
                            );
                          }}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;

                            if (
                              (keyCode >= 48 && keyCode <= 57) ||
                              keyCode == 13
                            ) {
                              // seterror(false);
                              if (
                                Number(formik.values.tpsLimit) >
                                Number(maxLimit?.tpsLimit)
                              ) {
                                seterror(true);
                              } else {
                                seterror(false);
                              }
                            } else {
                              event.preventDefault();
                              seterror(true);
                            }
                          }}
                        />

                     
                  
                        <label
                          className="d-block mb-0 mt-2"
                          style={{ marginTop: "-8px" }}
                        >
                          <span style={{ color: "red" }}>*</span>
                          (Max TPS Limit is {`${maxLimit?.tpsLimit}`})
                        </label>
                      </div>
                      
                      <div className="col-md-3">
                        <label
                          className="d-block mb-0"
                          style={{ marginTop: "-8px" }}
                        >
                          WhiteListing IP Address{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="row alignDivnew">
                          <div className="col d-flex align-items-center">
                            <input
                              // type="number"
                              id="part1"
                              className="impMargin1"
                              required
                              min={0}
                              max={255}
                              ref={inputRef1}
                              value={part1}
                              onChange={(event) =>
                                handleInputChange(event, setPart1)
                              }
                            />
                          </div>
                          <div class="col col_1">
                            <span class="spanMargin m-0">.</span>
                          </div>
                          <div className="col d-flex align-items-center">
                            <input
                              // type="number"
                              id="part2"
                              className="impMargin2"
                              required
                              min={0}
                              max={255}
                              value={part2}
                              ref={inputRef2}
                              onChange={(event) =>
                                handleInputChange2(event, setPart2)
                              }
                            />
                          </div>
                          <div class="col col_1">
                            <span class="spanMargin m-0">.</span>
                          </div>
                          <div className="col d-flex align-items-center">
                            <input
                              // type="number"
                              id="part3"
                              className="impMargin2"
                              required
                              min={0}
                              max={255}
                              value={part3}
                              ref={inputRef3}
                              onChange={(event) =>
                                handleInputChange3(event, setPart3)
                              }
                            />
                          </div>
                          <div class="col col_1">
                            <span class="spanMargin m-0">.</span>
                          </div>
                          <div className="col d-flex align-items-center">
                            <input
                              // type="number"
                              id="part4"
                              className="impMargin2"
                              required
                              min={0}
                              max={255}
                              value={part4}
                              ref={inputRef4}
                              onChange={(event) =>
                                handleInputChange4(event, setPart4)
                              }
                            />
                          </div>
                          {/* <div class="row">
                                    <button
                          style={{ marginLeft: "6px" }}
                          type="button"
                        onClick={()=>{
                          setPart1("*")
                          setPart2("*")
                          setPart3("*")
                          setPart4("*")
                        
                        }}
                          className="btn bg-gradient-secondary "
                        >
                          Reset
                          <i className="material-icons opacity-10">
                            settings_backup_restore
                          </i>
                        </button>
                                    </div> */}
                        </div>
                      </div>

                      {/* <div className="row">
                                  
                                    </div> */}
                      {/* <div class="row"> */}
                      <div class="col-md-12">
                        <div class="input-group input-group-outline ">
                          <label
                            for="exampleFormControlSelect1"
                            class="ms-0 mt-2 mb-0 d-inline-block me-3"
                          >
                            Secure(Encrypt) Message
                            <span class="text-danger fw-bold">*</span>
                          </label>

                          <SecureMessageRadioButton
                            parentCallback={callbackSecureMesage}
                          />
                        </div>
                      </div>
                      <div class="col-md-3 mt-3">
                        {secureMessage == "None" && (
                          <>
                            <div>
                              {/* <span>
                                      None(Default) means No additional action
                                      applied
                                    </span> */}
                            </div>
                          </>
                        )}
                        {/* {secureMessage == "Mask Number" && (
                                <>
                                  <div>
                                    <span>
                                      Mask Number: All the numbers in the
                                      message will be masked with *
                                    </span>
                                  </div>
                                </>
                              )} */}
                        {secureMessage == "Hashing" && (
                          <>
                            <div>
                              {/* <span>
                                      Hashing: Messages will be hashed using the
                                      secure SHA256 Algorithm and stored in
                                      database. Actual message cannot be
                                      retieved in this case.
                                    </span> */}
                            </div>
                          </>
                        )}
                        {secureMessage == "DES Encryption" && (
                          <>
                            {/* <div className="col-md-3 mt-3"> */}
                            <TextField
                              required
                              className="w-100"
                              label="Secret Key"
                              name="encryptedMessage"
                              variant="outlined"
                              size="small"
                              type="text"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="Secret Key"
                                      placement="top"
                                      arrow
                                      sx={{ color: "#85CBF2" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                              value={formik.values.encryptedMessage}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.encryptedMessage &&
                                Boolean(formik.errors.encryptedMessage)
                              }
                              helperText={
                                formik.touched.encryptedMessage &&
                                formik.errors.encryptedMessage
                              }
                            />
                            {/* </div> */}
                          </>
                        )}
                        {secureMessage == "AES256 Encryption" && (
                          <>
                            <div>
                              {/* <span>
                                      Messages will be encrypted using the
                                      latest AES256 Encryption Algorithm using a
                                      secret key(32 Characters) and the account
                                      password
                                    </span> */}
                              {/* <div className="col-md-3 mt-3"> */}
                              <TextField
                                required
                                className="w-100"
                                label="Secret Key"
                                name="encryptedMessage"
                                variant="outlined"
                                size="small"
                                type="text"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip
                                        title="Secret Key"
                                        placement="top"
                                        arrow
                                        sx={{ color: "#85CBF2" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                                value={formik.values.encryptedMessage}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.encryptedMessage &&
                                  Boolean(formik.errors.encryptedMessage)
                                }
                                helperText={
                                  formik.touched.encryptedMessage &&
                                  formik.errors.encryptedMessage
                                }
                              />
                            </div>
                            {/* </div> */}
                          </>
                        )}
                        {secureMessage == "Do Not Store" && (
                          <>
                            <div>
                              {/* <span>
                                      Do Not Store: Messages will not be stored
                                      in database
                                    </span> */}
                            </div>
                          </>
                        )}
                      </div>
                      {/* </div> */}
                      {/* <div class="row mt-3">
                        <form onSubmit={handleSubmit}>
                          <div className="ip_8">
                            <label htmlFor="part1">IP Address:</label>
                            <div className="row alignDivnew">
                              <div className="col-md-1 d-flex align-items-center">
                                <input
                               
                                  id="part1"
                                  className="impMargin1"
                                  required
                                  min={0}
                                  max={255}
                                  ref={inputRef1}
                                  value={part1}
                                  onChange={(event) =>
                                    handleInputChange(event, setPart1)
                                  }
                                />
                                <span>.</span>
                              </div>
                              <div className="col-md-1 d-flex align-items-center">
                                <input
                                  id="part2"
                                  className="impMargin2"
                                  min={0}
                                  max={255}
                                  value={part2}
                                  ref={inputRef2}
                                  onChange={(event) =>
                                    handleInputChange2(event)
                                  }
                                />
                                <span>.</span>
                              </div>
                              <div className="col-md-1 d-flex align-items-center">
                                <input
                                  id="part3"
                                  className="impMargin2"
                                  min={0}
                                  max={255}
                                  value={part3}
                                  ref={inputRef3}
                                  onChange={(event) =>
                                    handleInputChange3(event)
                                  }
                                />
                                <span>.</span>
                              </div>
                              <div className="col-md-1 d-flex align-items-center">
                                <input
                                  // type="number"
                                  id="part4"
                                  className="impMargin2"
                                  min={0}
                                  max={255}
                                  value={part4}
                                  ref={inputRef4}
                                  onChange={(event) =>
                                    handleInputChange4(event)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          
                        </form>
                      </div> */}
                      <div className="d-flex justify-content-between">
                        <button
                          style={{ marginLeft: "6px" }}
                          type="button"
                          onClick={formik.resetForm}
                          className="btn resetBtn_UP"
                        >
                          Reset
                          {/* <i className="material-icons opacity-10">
                              settings_backup_restore
                            </i> */}
                        </button>

                        <button
                          type="submit"
                          className="btn bg-gradient-primary "
                          disabled={
                            checkUsernameError != "" ||
                            Number(formik?.values?.tpsLimit) >
                              Number(maxLimit?.tpsLimit) ||
                            Number(formik?.values?.tpsLimit) === 0
                          }
                        >
                          Submit
                          {/* <i className="material-icons opacity-10">
                            arrow_right_alt
                          </i> */}
                        </button>
                      </div>

                      {/* <button type="button" className="btn btn-primary">
              Save
            </button> */}
                    </form>
                  </div>
                </div>

                <div className="d-flex mt-3 me-3 mb-3 justify-content-center">
                  <div className="main_box up_buttonStyle px-4">
                    <Link to="/dashboard/ViewUsers">
                      <p className="fw-bold text-white">View All Users</p>
                    </Link>
                  </div>
                </div>

                {/* <div className="text-end mt-2">
                  <p> Want to See Account Holders </p>
                  <Link
                    to="/dashboard/ViewUsers"
                    style={{ color: "#63B7E6", marginLeft: "30px" }}
                  >
                    <span>View All Users !!!</span>
                  </Link>
                </div> */}
              </div>

              {openTable == true && (
                <>
                  {data.length > 0 && (
                    <>
                      <div className="card-body">
                        <div className="container-fluid p-0">
                          <div className="card shadow-none border bg_blue mt-5">
                            <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                              Recently Added
                            </span>
                            <div className="p-4">
                              {/* <div className="d-flex justify-content-between my-3">
                                <select
                                  value={pageSize}
                                  className="dropdown"
                                  onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                  }}
                                >
                                  {[10, 25, 50].map((value, i) => {
                                    return (
                                      <option
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton1"
                                        value={value}
                                        key={value}
                                      >
                                        {" "}
                                        Show {value}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div> */}
                              <table
                                {...getTableProps()}
                                id="example"
                                className="table table-striped table-bordered dataTable table-sm mt-3"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                          )}
                                          className="text-center width_2"
                                        >
                                          {column.render("Header")}
                                          <span>
                                            {column.isSorted
                                              ? column.isSortedDesc
                                                ? "↑"
                                                : "↓"
                                              : ""}
                                          </span>

                                          {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                  {/* {rows.map((row) => {
prepareRow(row);
return (
<tr {...row.getRowProps()}>
 {row.cells.map((cell) => {
   return (
     <td {...cell.getCellProps()} className="text-center">
       {cell.render("Cell")}
     </td>
   );
 })}
</tr>
);
})} */}

                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                          return (
                                            <td
                                              {...cell.getCellProps()}
                                              className="text-center"
                                            >
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                {/* <tfoot>
{footerGroups.map((footerGroup) => (
<tr {...footerGroup.getFooterGroupProps()}>
{footerGroup.headers.map((column) => (
 <td className="text-center" {...column.getFooterProps}>
   {column.render("Footer")}
 </td>
))}
</tr>
))}
</tfoot> */}
                              </table>
                              {/* <div className="d-flex justify-content-between">
                                <div>
                                  <span>
                                    Page:
                                    <strong>
                                      {pageIndex + 1} of {pageOptions.length}
                                    </strong>
                                  </span>
                                </div>

                                <div id="nikhil">
 
                                  <button
                                    className="btn btn_primary m-0"
                                    type="button"
                                    disabled={!canPreviousPage}
                                    onClick={() => {
                                      previousPage();
                                    }}
                                  >
                                    Prev
                                  </button>

                                  <button
                                    className="btn btn_primary m-0"
                                    type="button"
                                    disabled={!canNextPage}
                                    onClick={() => {
                                      nextPage();
                                    }}
                                  >
                                    Next
                                  </button>
         </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}




